<template>
  <layout>
    <template v-slot:title>Sections</template>
    <template v-slot:header-buttons
      ><router-link to="/sections/create" class="btn btn-primary"
        >Create</router-link
      ></template
    >
    <div>
      <filter-control label="Filter sections" v-model="filter"></filter-control>
      <div v-if="sections.length > 0">
        <table class="table cells-top">
          <thead>
            <table-header
              @sort-click="sortClicked"
              :current-sort-field="sortField"
            ></table-header>
          </thead>
          <tbody>
            <table-row
              v-for="(section, index) in sections"
              :index="index"
              :key="section.id"
              :section="section"
              @edit="editClicked"
              @delete="deleteClicked"
            ></table-row>
          </tbody>
        </table>
        <pager
          :count="pages"
          :current-page="currentPage"
          @page-click="pageClicked"
        ></pager>
      </div>
      <div v-else class="mt-1"><p>No sections found.</p></div>
    </div>
    <template v-slot:modal>
      <confirm-delete-modal
        v-if="showDeleteModal"
        message="Are you sure you want to delete this section?"
        @confirm="deleteConfirmed"
        @cancel="deleteCanceled"
      />
    </template>
  </layout>
</template>
<script>
import documentModelMixin from "@/mixins/documentModel";
import FilterControl from "@/components/common/filtering/FilterControl.vue";
import Pager from "@/components/common/pagination/Pager.vue";
import TableHeader from "@/components/sections/TableHeader.vue";
import TableRow from "@/components/sections/TableRow.vue";
import ConfirmDeleteModal from "@/components/common/confirmations/ConfirmDeleteModal.vue";
import { direction, sort } from "@/util/sort";
import { PAGE_SIZE } from "@/constants/pagination";
import { SECTION } from "@/constants/contentControlTypes";
import contentControls from "@/services/word/contentControlsService";

const sortClicked = function (args) {
  this.sortField = args.field;
  this.sortDirection = args.direction;
};

const pageClicked = async function (pageNo) {
  this.currentPage = pageNo;
};

const deleteClicked = function (id) {
  this.selectedSectionId = id;
  this.showDeleteModal = true;
};

const deleteConfirmed = async function () {
  const id = this.selectedSectionId;
  const model = this.documentModel;
  await contentControls.delete(id);
  model.deleteContentControl(id);
  await this.saveDocumentModel(model);
  this.showDeleteModal = false;
};

const deleteCanceled = function () {
  this.selectedSectionId = null;
  this.showDeleteModal = false;
};

const editClicked = function (id) {
  this.$router.push(`/sections/edit/${id}`);
};

export default {
  components: {
    TableHeader,
    TableRow,
    FilterControl,
    Pager,
    ConfirmDeleteModal,
  },
  mixins: [documentModelMixin],
  data: function () {
    return {
      filter: "",
      sortField: "systemName",
      sortDirection: direction.ASCENDING,
      currentPage: 1,
      selectedSectionId: null,
      showDeleteModal: false,
    };
  },
  computed: {
    sections: function () {
      if (this.documentModel) {
        let sections = this.documentModel.findContentControlByType(SECTION);

        sections = sections.filter(
          (s) =>
            s.systemName.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1
        );
        sections.sort(sort((r) => r[this.sortField], this.sortDirection));
        sections = sections.slice(
          (this.currentPage - 1) * PAGE_SIZE,
          this.currentPage * PAGE_SIZE
        );

        return sections;
      }

      return [];
    },
    pages: function () {
      if (this.documentModel) {
        return Math.ceil(
          this.documentModel.findContentControlByType(SECTION).length /
            PAGE_SIZE
        );
      }

      return 1;
    },
  },
  watch: {
    filter: function () {
      this.currentPage = 1;
    },
  },
  methods: {
    sortClicked,
    pageClicked,
    deleteClicked,
    deleteConfirmed,
    deleteCanceled,
    editClicked,
  },
};
</script>
